<template>
    <div class="section-box">
        <el-row class="row-bg">
            <el-col :span="24" style="text-align: right">
                <el-button size="medium" type="primary" icon="el-icon-plus" plain @click="checkDetail()">新增</el-button>
                <el-button size="medium" type="primary" @click="GetNewsList()">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table :stripe="true" :data="tableData" style="width: 100%" height="666" border v-loading="listLoading" @row-click="checkDetail">
            <!-- eslint-disable  -->
            <el-table-column label="ID">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.id" placeholder="输入关键字搜索" @blur="GetNewsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.newsid || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="标题">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.title" placeholder="输入关键字搜索" @blur="GetNewsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.title || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="类型">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.newsType" placeholder="请选择类型" style="width: 100%" @change="GetNewsList()">
                            <el-option value="" label="请选择"></el-option>
                            <el-option :value="item.newstypeid" :label="item.name" v-for="(item, index) in newsTypeArr"
                                :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.newsTypeName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="是否置顶">
                <el-table-column show-overflow-tooltip width="180">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.istop" placeholder="请选择是否置顶" style="width: 100%" @change="GetNewsList()">
                            <el-option value="" label="请选择"></el-option>
                            <el-option :value="item.value" :label="item.label" v-for="(item, index) in isTopArr"
                                :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.istop == 0">否</span>
                        <span v-else>是</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="状态">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.statusId" placeholder="请选择状态" style="width: 100%" @change="GetNewsList()">
                            <el-option value="" label="请选择"></el-option>
                            <el-option :value="item.value" :label="item.label" v-for="(item, index) in statusArr"
                                :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.statu == 0">作废</span>
                        <span v-else>有效</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="浏览数">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.startCount" placeholder="开始数量" class="startCls" @blur="GetNewsList()"/> - 
                        <el-input size="mini" v-model="form.endCount" placeholder="结束数量" class="startCls" @blur="GetNewsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.browsecount || "0" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="创建时间">
                <el-table-column show-overflow-tooltip width="250">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker size="mini" v-model="form.EffectivityTime" type="daterange" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" style="width: 100%" range-separator="—" start-placeholder="开始日期" end-placeholder="结束日期" @change="GetNewsList()"></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.addtime || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <div style="margin: 10px; overflow: hidden" v-show="tableData.length">
            <div style="float: right">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="form.PageNo" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>

        <DetailsNews ref="newsDetail" />
    </div>
</template>

<script>
    // DOTO：静态展示数据 对接的时候可以删掉
    import {
        PERIOD
    } from "@/config/const/common.js";
    // End
    import {
        getStorageToken
    } from "@/utils/store";
    import {
        newListApi,
        newsType,
    } from "@/service/newsApi";
    import {
        couponsList
    } from "@/service/coupons";
    import DetailsNews from './index/newsDetail'
    export default {
        components: {
            DetailsNews
        },
        data() {
            return {
                PERIOD,
                listLoading: false,
                form: {
                    PageNo: 1,
                    PageSize: 10,
                    istop: "",
                    newsType:'',
                    statusId:'',
                    id:'',
                    title: "", 
                    EffectivityTime: [], //时间
                    startCount:'',
                    endCount:'',
                },
                searchData: {},
                oraginForm: {},
                total: 0, //总条数
                tableData: [],
                isTopArr: [{
                    value: '1',
                    label: '是'
                }, {
                    value: '0',
                    label: '否',
                }],
                statusArr:[{
                    value: '0',
                    label: '作废'
                }, {
                    value: '1',
                    label: '有效',
                }],
                newsTypeArr:[],
            };
        },
        activated() {
            this.handleSearch();
        },
        watch: {
    "form.endCount"(newVal, oldVal) {
        
        },
    },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form));
            this.tableData = [];
            this.getNewsType();
        },
        computed: {},
        mounted() {},
        methods: {
            getNewsType() {
                let data = {
                    pageNum: 1,
                    pageSize: 999,
                    rational: false
                }
                newsType(data)
                    .then((r) => {
                        if (r.Result != 1) {
                            return this.$message.error("列表异常,请联系管理员");
                        }
                        this.newsTypeArr = r.Data.datas
                    })
            },
            checkDetail(row) {
                console.log(row)
                if(row) {
                    this.$refs.newsDetail.open(row.newsid) 
                    return}
                this.$refs.newsDetail.open() 
            },
            //渲染列表
            handleSearch() {
                this.searchData = Object.assign({}, this.form);
                this.handleCurrentChange(1);
            },
            handleCurrentChange(val) {
                if (this.listLoading) return;
                this.form.PageNo = val;
                this.searchData.PageNo = val;
                this.GetNewsList();
            },
            //翻页
            handleSizeChange(val) {
                if (this.listLoading) return;
                this.form.PageNo = 1;
                this.form.PageSize = val;
                this.searchData.PageNo = 1;
                this.searchData.PageSize = val;
                this.GetNewsList();
            },
            // TODO：修改接口名 form参数 table展示数据 -> 平台、发单方角色select
            async GetNewsList() {
                const _this = this
                this.listLoading = true;
                var data = {
                    rational: true,
                    pageNum:this.form.PageNo,
                    pageSize:this.form.PageSize,
                }
                if (this.form.istop) data.istop = this.form.istop
                if (this.form.id) data.newsid = this.form.id
                if (this.form.newsType) data.newstypeid = this.form.newsType
                if (this.form.statusId) data.statu = this.form.statusId
                if (this.form.title) data.title = this.form.title
                if (this.form.startCount) data.browseCountStart = this.form.startCount
                if (this.form.endCount) data.browseCountEnd = this.form.endCount
                if (_this.form.EffectivityTime instanceof Array &&_this.form.EffectivityTime.length > 0) {
                    data.startAddTime = _this.form.EffectivityTime[0] + " 00:00:00";
                    data.endAddTime = _this.form.EffectivityTime[1] + " 23:59:59";
                    } 
                    else {
                    if (data.startAddTime) delete data.startAddTime;
                    if (data.endAddTime) delete data.endAddTime;
                    }



                

                let res = await newListApi(data);
                this.listLoading = false;
                if (res.Result != 1) {
                    return this.$message.error("列表异常,请联系管理员");
                }
                const {
                    Data
                } = res;
                const {
                    datas
                } = res.Data;
                this.tableData = datas;
                this.total = Data.total;
            },
            handleReset() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm));
                this.handleSearch();
            },
        },
    };
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
    .startCls{
        width: 80px;
    }
</style>